const state = {
  empresa: '',
  sigla_empresa: '',
  pusher_channel: '',
  id_empresa_firebase: ''
}

const getters = {
  getEmpresa: state => state.empresa,
  getSiglaEmpresa: state => state.sigla_empresa,
  getPusherChannel: state => state.pusher_channel,
  getIdEmpresaFirebase: state => state.id_empresa_firebase
}

const actions = {
  setEmpresa ({ commit }, value) {
    commit('SET_EMPRESA', value)
  },
  setSiglaEmpresa ({ commit }, value) {
    commit('SET_SIGLA_EMPRESA', value)
  },
  setPusherChannel ({ commit }, value) {
    commit('SET_PUSHER_CHANNEL', value)
  },
  setIdEmpresaFirebase ({ commit }, value) {
    commit('SET_ID_EMPRESA_FIREBASE', value)
  },
  resetEmpresaModule({ commit }) {
    commit('SET_EMPRESA', '')
    commit('SET_SIGLA_EMPRESA', '')
    commit('SET_PUSHER_CHANNEL', '')
    commit('SET_ID_EMPRESA_FIREBASE', '')
  }
}

const mutations = {
  SET_EMPRESA: (state, value) => (state.empresa = value),
  SET_SIGLA_EMPRESA: (state, value) => (state.sigla_empresa = value),
  SET_PUSHER_CHANNEL: (state, value) => (state.pusher_channel = value),
  SET_ID_EMPRESA_FIREBASE: (state, value) => (state.id_empresa_firebase = value),
}

export default {
  state,
  getters,
  actions,
  mutations,
}